import { inProgressPaths } from "@core/config/InProgressPaths";
import IntegrationInProgress from "../../pages/IntegrationInProgress";
import { authRoutes } from "@features/auth/routes";
import { bxRoutes } from "@features/bx/routes";
import { callCenterRoutes } from "@features/callCenter/routes";
import { cxRoutes } from "@features/cx/routes";
import { ixRoutes } from "@features/ix/routes";
import { mxRoutes } from "@features/mx";
import { onboardingRoute } from "@features/onboarding";
import { uxRoutes } from "@features/ux";
import { wxRoutes } from "@features/wx";
import { RouteObject } from "react-router-dom";
import NotFound from "../../pages/NotFound";
import ServerError from "../../pages/ServerError";
import { axRoutes } from "@features/ax";

export interface AppRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: AppRoute[];
}
export const routes: AppRoute[] = [
  ...authRoutes,
  ...onboardingRoute,
  ...cxRoutes,
  ...mxRoutes,
  ...bxRoutes,
  ...wxRoutes,
  ...uxRoutes,
  ...axRoutes,
  ...callCenterRoutes,
  ...ixRoutes,

  // Generate in-progress routes dynamically
  ...inProgressPaths.map(({ path }) => ({
    path,
    element: <IntegrationInProgress />,
  })),

  {
    path: "/500",
    element: <ServerError />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
  {
    path: "/in-progress",
    element: <IntegrationInProgress />,
  },
];

